import axios from "axios"

declare let apiEndpoint: string;
declare let searchApiEndpoint: string;
declare let clubfinderApiEndpoint: string;
declare let clubfinderCdnEndpoint: string;
declare let clubfinderSearchApiEndpoint: string;

export const sportmomentApi = axios.create({
    baseURL: apiEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
})

export const sportmomentSearchApiEndpoint = axios.create({
    baseURL: searchApiEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
})

export const clubfinderApi = axios.create({
    baseURL: clubfinderApiEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
})

export const clubfinderCdnApi = axios.create({
    baseURL: clubfinderCdnEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
})

export const clubfinderSearchApi = axios.create({
    baseURL: clubfinderSearchApiEndpoint,
    headers: {
        "Content-Type": "application/json",
    },
})

export const umbracoApi = axios.create({
    baseURL: '/umbraco/api',
    headers: {
        "Content-Type": "application/json",
    },
})
